"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require("babel-runtime/helpers/objectWithoutProperties");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _typeof2 = require("babel-runtime/helpers/typeof");

var _typeof3 = _interopRequireDefault(_typeof2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _Item = require("./Item");

var _Item2 = _interopRequireDefault(_Item);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function splitBy(interval, array) {
    var ret = [];
    var cur = [];
    var i = 0,
        j = 0;
    for (; i < array.length; i += 1, j = (j + 1) % interval) {
        cur.push(array[i]);
        if (j == interval - 1) {
            ret.push(cur);cur = [];
        }
    }
    if (cur.length) {
        ret.push(cur);
    }
    return ret;
}

function groupEvery(nColumn, array) {
    var ret = Array(nColumn).fill(null).map(function () {
        return [];
    });
    for (var i = 0; i < array.length; i += 1) {
        ret[i % nColumn].push(array[i]);
    }
    return ret;
}

function propagateProps(props, child, index) {
    var override = {};
    if (!child.props.labelCol) {
        override.labelCol = props.labelCol;
    }
    if (!child.props.wrapperCol) {
        override.wrapperCol = props.wrapperCol;
    }
    if (!child.props.labelAlign) {
        override.labelAlign = props.labelAlign;
    }
    if (!child.props.labelTextAlign) {
        override.labelTextAlign = props.labelTextAlign;
    }
    if (!child.props.wrapperTextAlign) {
        override.wrapperTextAlign = props.wrapperTextAlign;
    }
    if (!child.props.dataSource) {
        override.dataSource = props.dataSource;
    }
    if (child.key == null || typeof child.key == "undefined") {
        override.key = index;
    }
    return _react2.default.cloneElement(child, override);
}

function getPropColumn(props) {
    if (Array.isArray(props.columnSpans)) {
        return props.columnSpans.length;
    } else {
        return props.column;
    }
}

function getPropColumnSpan(props, columnIndex) {
    switch ((0, _typeof3.default)(props.columnSpans)) {
        case "function":
            return props.columnSpans(columnIndex);
        case "object":
            // yeah array IS some kind of function ...
            if (Array.isArray(props.columnSpans)) {
                return props.columnSpans[columnIndex];
            } else {
                return props.columnSpans.call(null, columnIndex);
            }
        case "undefined":
            return 1;
    }
    console.error("Invalid value for columnSpans", props.columnSpans);
}

var Detail = function (_React$Component) {
    (0, _inherits3.default)(Detail, _React$Component);

    function Detail(props) {
        (0, _classCallCheck3.default)(this, Detail);
        return (0, _possibleConstructorReturn3.default)(this, (Detail.__proto__ || (0, _getPrototypeOf2.default)(Detail)).call(this, props));
    }

    (0, _createClass3.default)(Detail, [{
        key: "normalizeChildren",
        value: function normalizeChildren(nColumn) {
            var _this2 = this;

            var ret = _react2.default.Children.toArray(this.props.children);
            if (this.props.direction == "hoz") {
                var mod = ret.length % nColumn;
                if (mod != 0) {
                    ret = ret.concat(Array(nColumn - mod).fill(_react2.default.createElement(_Item2.default, { placeholder: true })));
                }
            } else {
                var nRows = Math.ceil(ret.length / nColumn);
                var _mod = ret.length % nRows;
                if (_mod != 0) {
                    ret = ret.concat(Array(nRows - _mod).fill(_react2.default.createElement(_Item2.default, { placeholder: true })));
                }
            }
            ret = ret.map(function (child, index) {
                return propagateProps(_this2.props, child, index);
            });
            return ret;
        }
    }, {
        key: "render",
        value: function render() {
            var _this3 = this;

            var _props = this.props,
                className = _props.className,
                labelCol = _props.labelCol,
                wrapperCol = _props.wrapperCol,
                labelAlign = _props.labelAlign,
                labelTextAlign = _props.labelTextAlign,
                wrapperTextAlign = _props.wrapperTextAlign,
                dataSource = _props.dataSource,
                entries = _props.entries,
                column = _props.column,
                title = _props.title,
                columnSpans = _props.columnSpans,
                direction = _props.direction,
                children = _props.children,
                rest = (0, _objectWithoutProperties3.default)(_props, ["className", "labelCol", "wrapperCol", "labelAlign", "labelTextAlign", "wrapperTextAlign", "dataSource", "entries", "column", "title", "columnSpans", "direction", "children"]);


            var nColumn = getPropColumn(this.props);
            var cols = null;

            var normalized = this.normalizeChildren(nColumn);
            switch (direction) {
                case "hoz":
                    cols = groupEvery(column, normalized);
                    break;
                case "ver":
                    cols = splitBy(Math.ceil(normalized.length / column), normalized);
                    break;
            }

            var hasTitle = typeof this.props.title != "undefined";

            return _react2.default.createElement(
                "div",
                (0, _extends3.default)({
                    className: (0, _classnames2.default)("cn-detail", { "cn-detail-titled": hasTitle }, className)
                }, rest),
                !hasTitle ? null : _react2.default.createElement(
                    "div",
                    { className: "cn-detail-title" },
                    title
                ),
                _react2.default.createElement(
                    "div",
                    { className: "cn-detail-content" },
                    cols.map(function (col, index) {
                        return _react2.default.createElement(
                            "div",
                            {
                                className: "cn-detail-row",
                                key: col.length ? col[0].key : "detailCol-" + index,
                                style: { flexGrow: getPropColumnSpan(_this3.props, index) }
                            },
                            col
                        );
                    })
                )
            );
        }
    }]);
    return Detail;
}(_react2.default.Component);

Detail.propTypes = {
    className: _propTypes2.default.string,
    style: _propTypes2.default.object,
    labelCol: _propTypes2.default.object,
    wrapperCol: _propTypes2.default.object,
    labelAlign: _propTypes2.default.oneOf(["left", "top"]),
    labelTextAlign: _propTypes2.default.oneOf(["left", "center", "right"]),
    wrapperTextAlign: _propTypes2.default.oneOf(["left", "center", "right"]),
    dataSource: _propTypes2.default.object,
    column: _propTypes2.default.number,
    title: _propTypes2.default.node,
    columnSpans: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.func]),
    direction: _propTypes2.default.oneOf(["hoz", "ver"])
};
Detail.defaultProps = {
    labelAlign: "top",
    labelTextAlign: "left",
    wrapperTextAlign: "left",
    column: 3,
    labelCol: { span: 6 },
    wrapperCol: { span: 18 },
    direction: "hoz"
};
exports.default = Detail;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-detail@0.0.6@@alicd/crui-detail/lib/Detail.js
// module id = 629
// module chunks = 0